import React, { FC, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAppSelector } from 'app/store/store.hooks';
import { selectCategory } from 'entities/Category/Category.slice';

interface IComponentProps {
  catalogName: string;
}

export const CatalogTitle: FC<IComponentProps> = ({ catalogName }) => {
  // category
  const category = useAppSelector(selectCategory);

  const { catalogId, categoryId } = useParams<{ catalogId: string; categoryId: string }>();
  const [params] = useSearchParams();

  const search = params.get('search');

  const title = useMemo(() => {
    switch (true) {
      case search !== null: {
        return `Результаты для “${search}”`;
      }
      case !!categoryId: {
        return category?.displayName ?? '';
      }
      default: {
        return catalogName;
      }
    }
  }, [catalogId, catalogName, categoryId, category, search]);

  return title.length ? <div className="mb-14 ff-regular fs-xxl">{title}</div> : null;
};
